import React from 'react';
import ShuttleInformation from '../shuttle-information/ShuttleInformation';
import AccessHours from 'common/spot-details/access-hours';
import FacilityLocation from '../facility-location/FacilityLocation';
import SafetyAmenities from '../safety-amenities/SafetyAmenities';
import ThingsYouShouldKnow from 'common/spot-details/things-you-should-know';
import HowToRedeemArrivalDeparture from '../arrival-departure-redemption-instructions/HowToRedeemArrivalDeparture';
import FAQPanels from 'common/spot-details/faq';
import TrustSealValueProps from 'common/spot-details/trust-seal-and-value-props/TrustSealValueProps';
import SpotDetailsHeader from '../header/SpotDetailsHeader';
export const AirportDetails = ({ shuttle, title, iataCode, facility, selectedRate, linearMeters, amenities, hasInOutAmenity, facilityRestrictions, cancellationAllowed, airportPercentLowerPrice, showBenefitMessage, }) => {
    return (<>
            <SpotDetailsHeader facility={facility} percentLowerPrice={airportPercentLowerPrice} linearMeters={linearMeters} walkingMeters={null} showBenefitMessage={showBenefitMessage}/>
            <ShuttleInformation shuttle={shuttle} facilityTitle={title} iataCode={iataCode}/>
            <AccessHours facility={facility} rate={selectedRate} sectionTitle="Facility Access Hours"/>
            <FacilityLocation facility={facility} linearMeters={linearMeters} walkingMeters={null}/>
            <SafetyAmenities amenities={amenities}/>
            <ThingsYouShouldKnow hasInOutAmenity={hasInOutAmenity} restrictions={facilityRestrictions}/>
            <HowToRedeemArrivalDeparture facility={facility}/>
            <FAQPanels cancellationAllowed={cancellationAllowed}/>
            <TrustSealValueProps />
        </>);
};
export default AirportDetails;
